<template>
  <div :class="['editor-detail-publications-skeleton', { _mobile: isMobile }]">
    <div class="editor-detail-publications-skeleton__title"></div>
    <ul class="editor-detail-publications-skeleton__list">
      <li
        v-for="index in 3"
        :key="index"
        class="editor-detail-publications-skeleton__item"
      ></li>
    </ul>
  </div>
</template>

<script setup lang="ts">
const isMobile: boolean = useIsMobile();
</script>

<style lang="less">
.editor-detail-publications-skeleton {
  .flex-column(@size-x6);
  .box-shadow();

  padding: @size-x8;
  border-radius: @main-size;

  &__title {
    .skeleton(320px, 39px);
  }

  &__list {
    .flex-column(@size-x5);
  }

  &__item {
    .skeleton(70%, 21px);
  }

  &._mobile {
    padding: @size-x6;
  }

  &._mobile &__title {
    width: 240px;
    height: 30px;
  }

  &._mobile &__item {
    width: 95%;
  }
}
</style>
